import { useEffect, useState } from "react";
import { FileText } from "lucide-react";
import api, { formatApiErrorDetail } from "../../lib/api";
import { toast } from "../../components/ui/sonner";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { CUSTOM_ORDER_STATUSES } from "../../lib/constants";

export function CustomOrdersManager({ onChange }) {
  const [orders, setOrders] = useState([]);

  const load = () => api.get("/custom-orders").then((res) => setOrders(res.data));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.put(`/custom-orders/${id}`, { status });
      toast.success("Status updated");
      load();
      onChange?.();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Update failed");
    }
  };

  return (
    <div data-testid="admin-custom-orders-manager" className="border border-amber-500/10 rounded-md overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow className="border-amber-500/10">
            <TableHead>Customer</TableHead>
            <TableHead>Part Requested</TableHead>
            <TableHead>Vehicle / Equipment</TableHead>
            <TableHead>Qty</TableHead>
            <TableHead>Files</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {orders.map((o) => (
            <TableRow key={o.id} className="border-amber-500/10" data-testid={`admin-custom-order-row-${o.id}`}>
              <TableCell className="text-white">{o.name}<div className="text-xs text-zinc-500">{o.email}</div></TableCell>
              <TableCell className="text-zinc-400 text-sm">{o.part_name}<div className="text-xs text-zinc-500">{o.category}</div></TableCell>
              <TableCell className="text-zinc-400 text-sm">{o.target_vehicle_equipment}</TableCell>
              <TableCell className="text-zinc-400 text-sm">{o.quantity}</TableCell>
              <TableCell>
                {(o.attachments || []).length > 0 ? (
                  <div className="flex flex-col gap-1">
                    {o.attachments.map((a, idx) => (
                      <a key={idx} href={a} target="_blank" rel="noreferrer" data-testid={`admin-custom-order-attachment-${o.id}-${idx}`} className="flex items-center gap-1 text-xs text-amber-light hover:underline">
                        <FileText className="h-3 w-3" /> File {idx + 1}
                      </a>
                    ))}
                  </div>
                ) : (
                  <span className="text-xs text-zinc-600">—</span>
                )}
              </TableCell>
              <TableCell>
                <Select value={o.status} onValueChange={(v) => updateStatus(o.id, v)}>
                  <SelectTrigger data-testid={`admin-custom-order-status-select-${o.id}`} className="w-40">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {CUSTOM_ORDER_STATUSES.map((s) => <SelectItem key={s} value={s}>{s.replace("_", " ")}</SelectItem>)}
                  </SelectContent>
                </Select>
              </TableCell>
            </TableRow>
          ))}
          {orders.length === 0 && (
            <TableRow><TableCell colSpan={6} className="text-center text-zinc-500 py-8" data-testid="admin-custom-orders-empty">No custom order requests yet.</TableCell></TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
